import config from '@/config/index.js';

// 请求
const templates = {
    url: `/beyonder/api/v1/evaluations/templates`,
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
const list = {
  url: `/beyonder/api/v2/evaluations/{order_id}`,
  method: 'get'
};
const create = {
    url: '/beyonder/api/v2/evaluations',
    method: 'post',
    requstTypeJson: true
};
export default {
  templates,
  list,
  create
};



// WEBPACK FOOTER //
// ./src/service/evaluations/index.js